import React, { useState } from 'react';
import Head from 'next/head';
import useTranslation from '@modules/hooks/useTranslation';
import GuideContents from '@feature/guide';
import styles from '@styles/guide/useGuide.module.scss';
import SetType from '@feature/guide/SetType';

const Guide = () => {
    const { t } = useTranslation('guide');

    const [type, setType] = useState<'STS' | 'TTS'>('STS');

    return (
        <>
            <Head>
                <title>{t('title')}</title>
                <meta property="og:title" content={t('title')} />
            </Head>

            <div id="container" className={styles.container}>
                <div className={styles.title_area}>
                    <h1 className={styles.title}>Studio Guide</h1>
                    <SetType type={type} setType={setType} />
                </div>

                <GuideContents type={type} />
            </div>
        </>
    );
};

export default Guide;
